import {
  OtherBenefitsFlg,
  RetirementInvoiceOrder,
} from "../../assets/data/Constants";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    contractorName: "契約者（法人）名",
    keyword: "contractorName",
    type: "contractorAndNumber",
    showLine: false,
  },
  {
    title: "",
    keyword: "title",
    type: "lineTitle",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
    helpicon: true,
    helpText: "被共済職員の番号です。",
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
    helpicon: true,
    helpText:
      "退職する被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されない場合があります。",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
  },
  {
    title: "福祉医療機構以外からの退職金受け取りの有無",
    keyword: "prefectureRetirementJoinFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(OtherBenefitsFlg),
    helpicon: true,
    helpText:
      "福祉医療機構以外からも退職金を受け取る場合は「有」、福祉医療機構からだけの場合は「無」を選択してください。",
    requiredIcon: true,
  },
  {
    title: "退職手当金請求の順番",
    keyword: "retirementInvoiceOrder",
    type: "radio",
    radioPropsList: TkGetCodeList(RetirementInvoiceOrder),
    helpicon: true,
    helpText:
      "福祉医療機構以外からも退職金を受け取る場合は、福祉医療機構を先に請求するか、後に請求するか選択してください。同時に請求することはできません。特別な事情がない限り、初期表示されている順番を変更しないようにしてください。",
    requiredIcon: true,
  },
];

const schema = {
  prefectureRetirementJoinFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  retirementInvoiceOrder: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { fakeTableList, schema, stepper };
